export const RECAPTCHA_ACTIONS = {
  addAlertLineReport: "add_alert_line_report",
};
